// ** Redux Imports
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

// ** API Imports
import axios from '@src/service/axios';

import { toast } from 'react-toastify';

export const getTaxmaster = createAsyncThunk('taxmasterSliceData/getTaxmaster', async () => {
    try {
        let response = await axios.get('/Taxmaster', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const getTaxmasteroption = createAsyncThunk('taxmasterSliceData/getTaxmasteroption', async () => {
    try {
        let response = await axios.get('/Taxmaster?option=true', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const deletetaxmaster = createAsyncThunk('taxmasterSliceData/deletetaxmaster', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/Taxmaster/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Taxmaster deleted successfully.');
        await dispatch(getTaxmaster());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const createTaxmaster = createAsyncThunk('taxmasterSliceData/createTaxmaster', async (data, { dispatch }) => {
    try {
        let response = await axios.post('/Taxmaster', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Taxmaster added succesfully.');
        await dispatch(getTaxmaster());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateTaxmaster = createAsyncThunk('taxmasterSliceData/updateTaxmaster', async (data, { dispatch }) => {
    try {
        let response = await axios.put('/Taxmaster/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Taxmaster updated succesfully.');
        await dispatch(getTaxmaster());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});

export const updateTaxmasterStatus = createAsyncThunk('taxmasterSliceData/updateTaxmasterStatus', async (id, { dispatch }) => {
    try {
        let response = await axios.put('/Taxmaster/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Status Updated Succesfully');
        await dispatch(getTaxmaster());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        console.log('err', err);
        return Promise.reject(err);
    }
});
export const taxmasterSlice = createSlice({
    name: 'taxmasterSliceData',
    initialState: {
        taxmaster: [],
        taxmasteroption: []
        // taxmasterStatus: []
    },
    extraReducers: (builder) => {
        builder.addCase(getTaxmaster.fulfilled, (state, action) => {
            state.taxmaster = action?.payload;
            return;
        });
        builder.addCase(getTaxmasteroption.fulfilled, (state, action) => {
            state.taxmasteroption = action?.payload;
            return;
        });
    }
});

export default taxmasterSlice.reducer;
